import { Brand, Stage } from '@org-avp/models';

export type InternalIdleAppConfig = null | {
  url: string;
  owner: string | ((url: string) => string);
  config: string | null;
};
export type IdleAppConfig = null | {
  url: string;
  owner: string;
  config: string | null;
};
export const getDefaultIdleApp = (stage: Stage, brand: Brand): IdleAppConfig => {
  const data = idleAppDefaults[brand]?.[stage];
  if (!data) return null;

  const owner = typeof data.owner === 'function' ? data.owner(data.url) : data.owner;

  return {
    url: data.url,
    owner,
    config: data.config,
  };
};
export const defaultIdleAppOwnerFn = (url: string) => new URL(url).hostname;
export const defaultIdleAppConfig = (stage: Stage) =>
  JSON.stringify(`Device registered on ${stage} stage. All systems nominal. Don't panic 🚀`);

const IDLE_APP_CONFIG_URL_MAP: Record<Stage, Record<string, string>> = {
  [Stage.DEVELOP]: {
    'https://naap-demo-iframe-app.develop.avp.tech': 'https://naap-demo-iframe-app.develop.avp.tech',
    'https://pwa.int.newretail.avp.tech': 'https://pwa.int.newretail.avp.tech/editMode',
  },
  [Stage.PREPROD]: {
    'https://pwa.int.newretail.avp.tech': 'https://pwa.int.newretail.avp.tech/editMode',
  },
  [Stage.PROD]: {},
};

/**
 * Returns the config page URL for the given idle app URL on the given stage,
 * or `undefined` if no config page is registered.
 */
export function getIdleAppConfigUrl(stage: Stage, idleAppUrl: string): string | undefined {
  try {
    const origin = new URL(idleAppUrl).origin;
    return IDLE_APP_CONFIG_URL_MAP[stage]?.[origin];
  } catch {
    return undefined;
  }
}

export const idleAppDefaults: Partial<Record<Brand, Partial<Record<Stage, InternalIdleAppConfig>>>> = {
  [Brand.AUDI]: {
    [Stage.DEVELOP]: {
      url: 'https://naap-demo-iframe-app.develop.avp.tech',
      owner: defaultIdleAppOwnerFn,
      config: defaultIdleAppConfig(Stage.DEVELOP),
    },
    [Stage.PREPROD]: {
      url: 'https://pwa.int.newretail.avp.tech/?displayName=123',
      owner: defaultIdleAppOwnerFn,
      config: defaultIdleAppConfig(Stage.PREPROD),
    },
    [Stage.PROD]: {
      url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
      owner: 'api.prod.newretail.avp.tech',
      config: null,
    },
  },

  [Brand.BENTLEY]: {
    // [Stage.DEVELOP]: {}
    // [Stage.PREPROD]: {}
    [Stage.PROD]: {
      url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
      owner: 'api.prod.newretail.avp.tech',
      config: null,
    },
  },

  [Brand.SEAT]: {
    // [Stage.DEVELOP]: {}
    // [Stage.PREPROD]: {}
    [Stage.PROD]: {
      url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
      owner: 'api.prod.newretail.avp.tech',
      config: null,
    },
  },

  [Brand.VW]: {
    [Stage.DEVELOP]: {
      url: 'https://naap-demo-iframe-app.develop.avp.tech',
      owner: defaultIdleAppOwnerFn,
      config: defaultIdleAppConfig(Stage.DEVELOP),
    },
    [Stage.PREPROD]: {
      url: 'https://pwa.int.newretail.avp.tech/?displayName=123',
      owner: defaultIdleAppOwnerFn,
      config: defaultIdleAppConfig(Stage.PREPROD),
    },
    [Stage.PROD]: {
      url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
      owner: 'api.prod.newretail.avp.tech',
      config: null,
    },
  },

  [Brand.VW_NUTZFAHRZEUGE]: {
    // [Stage.DEVELOP]: {}
    // [Stage.PREPROD]: {}
    [Stage.PROD]: {
      url: 'https://pwa.prod.newretail.avp.tech/?displayName=123',
      owner: 'api.prod.newretail.avp.tech',
      config: null,
    },
  },
};
